import React, { useEffect } from 'react';
import { IProps } from './GtmDataLayer.interface';
import { useOptimizelyFormsEvents } from '@/hooks/useOptimizelyFormsEvents';
import { dataLayerPush } from '@/utils/gtm';

const GtmDataLayer: React.FC<IProps> = ({ enabled, gtmDataLayerObject }) => {
    if (enabled === true) {
        useOptimizelyFormsEvents();
    }

    useEffect(() => {
        dataLayerPush(gtmDataLayerObject);
    }, [gtmDataLayerObject]);

    return null;
};

export default GtmDataLayer;
